<div class="modal-overlay" (click)="onClose()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <!-- <div class="modal-header">
      <h3>Layout settings</h3>
      <button class="close-btn" (click)="onClose()">×</button>
    </div> -->

    <div class="modal-body">
      <!-- Base Margin Section -->
      <div class="row">
        <label class="section-label">Base Margin</label>
        <div class="margin-selector">
          <div
            class="margin-tile"
            [class.active]="baseMargin === 0"
            (click)="onBaseMarginChange(0)"
          >
            <div class="preview margin-preview">
              <div class="margin-inner" style="padding: 0%"></div>
            </div>
            <div class="label">0%</div>
          </div>

          <div
            class="margin-tile"
            [class.active]="baseMargin === 10"
            (click)="onBaseMarginChange(10)"
          >
            <div class="preview margin-preview">
              <div class="margin-inner" style="padding: 10%"></div>
            </div>
            <div class="label">10%</div>
          </div>

          <div
            class="margin-tile"
            [class.active]="baseMargin === 20"
            (click)="onBaseMarginChange(20)"
          >
            <div class="preview margin-preview">
              <div class="margin-inner" style="padding: 20%"></div>
            </div>
            <div class="label">20%</div>
          </div>
        </div>
      </div>

      <!-- Layout Type Section -->
      <div class="row">
        <label class="section-label">Layout Type</label>
        <div class="type-selector">
          <div
            class="type-tile"
            [class.active]="type === 'text'"
            (click)="onTypeChange('text')"
          >
            <div class="preview text-layout"></div>
            <div class="label">Text</div>
          </div>

          <div
            class="type-tile"
            [class.active]="type === 'title-subtitle'"
            (click)="onTypeChange('title-subtitle')"
          >
            <div class="preview title-subtitle-layout"></div>
            <div class="label">Title/Subtitle</div>
          </div>

          <div
            class="type-tile"
            [class.active]="type === 'images-2'"
            (click)="onTypeChange('images-2')"
          >
            <div class="preview images-2-layout"></div>
            <div class="label">Images (2)</div>
          </div>

          <div
            class="type-tile"
            [class.active]="type === 'images-3'"
            (click)="onTypeChange('images-3')"
          >
            <div class="preview images-3-layout"></div>
            <div class="label">Images (3)</div>
          </div>

          <div
            class="type-tile"
            [class.active]="type === 'image-label'"
            (click)="onTypeChange('image-label')"
          >
            <div class="preview image-label-layout"></div>
            <div class="label">Image + Label</div>
          </div>

          <div
            class="type-tile"
            [class.active]="type === 'video'"
            (click)="onTypeChange('video')"
          >
            <div class="preview video-layout"></div>
            <div class="label">Video</div>
          </div>
        </div>
      </div>

      <div class="layout-description" [ngSwitch]="type">
        <div *ngSwitchCase="'text'" class="description">
          <p>Text centered in the middle of the slide</p>
        </div>

        <div *ngSwitchCase="'title-subtitle'" class="description">
          <p>Title above, subtitle below in a rectangle</p>
        </div>

        <div *ngSwitchCase="'images-2'" class="description">
          <p>Two images in a row with labels above</p>
        </div>

        <div *ngSwitchCase="'images-3'" class="description">
          <p>Three images in a row with labels above</p>
        </div>

        <div *ngSwitchCase="'image-label'" class="description">
          <p>Label on the left, image on the right</p>
        </div>

        <div *ngSwitchCase="'video'" class="description">
          <p>Video positioned at the top of the slide</p>
        </div>
      </div>

      <div class="modal-footer">
        <button class="secondary" (click)="onClose()">Cancel</button>
        <button class="primary" (click)="onSave()">Apply</button>
      </div>
    </div>
  </div>
</div>
